import React from "react";
import { Typography } from "antd";
import Reveal from "../components/common/Reveal";
import HubButton from "../components/common/HubButton";

import masculinoImg from "../assets/images/masculino-avatar.png";
import femininoImg from "../assets/images/feminino-avatar.png";
import geralImg from "../assets/images/geral-avatar.png";

import "../styles/home.css";

const { Title, Paragraph } = Typography;

export default function Home() {
  return (
    <section className="hub-page">
      <div className="hub-container">

        <Reveal>
          <div className="hub-header">
            <Title className="hub-title">
              Bora pro grupo?
            </Title>

            <Paragraph className="hub-description">
              Escolha o grupo e receba as melhores promoções todos os dias.
            </Paragraph>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="hub-buttons">

            <HubButton
              to="/masculino"
              title="Moda Masculina"
              subtitle="Ofertas diárias e cupons"
              image={masculinoImg}
            />
{/* 
            <HubButton
              to="/feminino"
              title="Perfumes Femininos"
              subtitle="Importados e nacionais"
              image={femininoImg}
            />  */}

            <HubButton
              to="/perfumes"
              title="Perfumes"
              subtitle="Ofertas diárias e cupons"
              image={geralImg}
            />

          </div>
        </Reveal>

      </div>
    </section>
  );
}